import doRequest from "../helpers";
import { getToken } from "../auth/tokenAuth";
import { getUserId } from "services/storage/general";
import {
    appointmentsMapper,
    getBodyToAddOrUpdateRequestStep1,
    getBodyToAddOrUpdateRequestStep2
} from "./helpers";

export const requestGetAppointmentsByAllAdvisers = async ({
    date: fecha, 
    page: pagina
}) => {
    const [result, err] = await doRequest(
        "/Asesorias/Leer", "POST", 
        { 
            codUsuario: getUserId(),
            fecha, 
            pagina 
        }, getToken());
    if (err)
        return false;
    const { data: dataFetch } = result;
    if (dataFetch?.state === 1) 
        return dataFetch?.data.horariosAsesores.map(appointmentsMapper);
    return null; 
}
export const requestGetAppointmentsWeekByAdviser = async ({
    adviserCode: idCodPsicologo,
    date: fecha
}) => {
    const [result, err] = await doRequest(
        "/Asesorias/SemanaAsesores", "POST", 
        { 
            codUsuario: getUserId(),
            idCodPsicologo, 
            fecha 
        }, getToken());
    if (err)
        return false;
    const { data: dataFetch } = result;
    if (dataFetch?.state === 1) 
        return dataFetch?.data.semanaAsesores.map(appointmentsMapper);
    return null;
}
export const requestCreateAppointment = async form => {
    const body ={
        codigoUsuario: getUserId(),
        ...getBodyToAddOrUpdateRequestStep1(form.step1),
        ...getBodyToAddOrUpdateRequestStep2(form.step2)
    };
    const [result, err] = await doRequest(
        "/CrearAsesoriaPsicologica", "POST", 
        body, getToken());
    if (err)
        return {
            success: false,
            message: null
        };
    const { data } = result;
    if (data?.state === 1) {
        return {
            success: true,
            message: null
        };
    }
    return {
        success: data?.data.exito,
        message: data?.data.mensaje
    };
}
export const requestGetAvailableSchedules = async ({
    date: fecha, 
    timeStart: horaInicio, 
    appointmentId: idAsesoria,
    isPresential: esPresencial
}) => {
    const [result, err] = await doRequest(
        "/AsesorPsicologo/Disponible", "POST",
        { 
            fecha,
            horaInicio, 
            idAsesoria,
            esPresencial
        }, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;
    if (dataFetch?.state === 1)
        return dataFetch?.data.asesoresDisponibles.map(({ 
            asesor: {
                idPsicologo: id,
                nombrePsicologo: name
            }, 
            idAsesoriaFecha: appointmentDateId 
        }) => {
            return {
                appointmentDateId,
                adviser: {
                    id,
                    name
                }
            }
        });
    return null;
}
export const requestGetUpcomingAvailableSchedules = async ({
    date: fecha, 
    timeStart: horaInicio, 
    appointmentId: idAsesoria,
    isPresential: esPresencial
}) => {
    const [result, err] = await doRequest(
        "/AsesorPsicologo/ProximosDisponibles", "POST",
        { 
            fecha, 
            horaInicio, 
            idAsesoria,
            esPresencial
        }, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;
    if (dataFetch?.state !== 1)
        return null;
    return dataFetch?.data.asesoresProxDisponibles.map(({ 
        asesor: {
            codigoPsicologo: id,
            nombrePsicologo: name
        }, 
        fecha: date, 
        horaInicio: timeStart, horaFin: timeEnd,
        idAsesoriaFecha: appointmentDateId 
    }) => {
        return {
            appointmentDateId,
            adviser: {
                id,
                name
            },
            date, time: {
                start: timeStart,
                end: timeEnd
            }
        }
    });
}
export const requestReassignSchedule = async ({
    reservationId: idReservaAsesoria, 
    appointmentDateId: idAsesoriaFecha
}) => {
    const [result, err] = await doRequest(
        "/AsesorPsicologo/Reasignar", "POST",
        { 
            idReservaAsesoria, 
            idAsesoriaFecha }, getToken());
    if (err) 
        return false;
        const { data: dataFetch } = result;
    if (dataFetch?.state === 1) 
        return dataFetch?.data.exito;
    return false;
}
export const requestReassignUpcomingSchedule = async ({
    reservationId: idReservaAsesoria, 
    appointmentDateId: idAsesoriaFecha, 
    timeStart: horaInicio
}) => {
    const [result, err] = await doRequest(
        "/AsesorPsicologo/ReasignarProximo", "POST",
        { 
            idReservaAsesoria, 
            idAsesoriaFecha,
            horaInicio }, getToken());
    if (err) 
        return false;
        const { data: dataFetch } = result;
    if (dataFetch?.state === 1) 
        return dataFetch?.data.exito;
    return false;
}
export const requestUserHasAssociatedAppointments = async () => {
    const [result, err] = await doRequest(
        `/Asesorias/TieneAsesorias/${getUserId()}`, "GET",
        null, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;
    if (dataFetch?.state !== 1) 
        return null;
    return dataFetch.data.tiene;
}
export const requestSwitchShiftOfSchedule = async ({
    activate,
    inactivate
}) => {
    let body = { activar: activate ? true : false };
    if (activate) {
        const { 
            inactivityId: idAsesoriaInactividad
        } = activate;
        body = {
            ...body,
            idAsesoriaInactividad
        };
    }
    else {
        const { 
            durationId: idDuracion, 
            date: fecha , 
            timeStart: horaInicio } = inactivate;
        body = {
            ...body,
            idDuracion, 
            fecha,
            horaInicio
        };
    }
    const [result, err] = await doRequest(
        "/Asesorias/CambiarTurno", "POST", 
        body, getToken());
    if (err)
        return false;
    const { data } = result;
    if (data?.state === 1) 
        return data?.data.exito;
    return data?.data.exito;
}
export const requestTakeAttendance = async (idReservaAsesoria, asistio) => {
    const [result, err] = await doRequest(
        "/ReservaAsesoria/Asistencia", "POST", 
        {
            idReservaAsesoria, asistio
        }, getToken());
    if (err)
        return false;
    const { data } = result;
    if (data?.state === 1) 
        return data?.data.exito;
    return data?.data.exito;
}
export const requestGetDateOfNextReservation = async alumno => {
    const [result, err] = await doRequest(
        "/ReservaAsesoria/FechaReservaAlumno", "POST",
        {
            alumno, 
            codUsuario: getUserId() 
        }, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;
    if (dataFetch?.state !== 1) 
        return null;
    const { fechaAlumnoProx } = dataFetch?.data;
    if (!fechaAlumnoProx) 
        return null;
    const { CodAlumno, fecha } = fechaAlumnoProx;
    return {
        date: fecha,
        studentId: CodAlumno
    };
}
export const requestGetDateAsPaginated = async (alumno, indiceUltimo, siguiente) => {
    const [result, err] = await doRequest(
        "/ReservaAsesoria/FechaReservaPaginado", "POST",
        {
            alumno, 
            codUsuario: getUserId(),
            siguiente, indiceUltimo
        }, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;
    if (dataFetch?.state === 1)
        return dataFetch?.data.fechaSegunIndice.fecha;
    return null;
}
export const requestGetAppointmentsForAdviser = async ({
    studentId: alumno, 
    date: fecha
}) => {
    const [result, err] = await doRequest(
        "/Asesoria/ListarBuscarReservas", "POST",
        {
            alumno, 
            fecha,
            codUsuario: getUserId() 
        }, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;
    if (dataFetch?.state === 1)
        return dataFetch?.data.reservasDelAlumno.map(appointmentsMapper);
    return null;
}
export const requestGetReasons = async () => {
    const [result, err] = await doRequest(
        `/psychotherapyappointment/reasons`, "GET",
        null, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;
    if (dataFetch?.state !== 1) 
        return null;
    return dataFetch.data.map(reason => {
        return {
            value: reason.id,
            text: reason.descripcion
        }
    });
}
export const requestGetSession = async (reservationId) => {
    const [result, err] = await doRequest(
        `/psychotherapyappointment/session/${reservationId}`, "GET",
        null, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;
    if (dataFetch?.state !== 1) 
        return null;
    return dataFetch.data;
}
export const requestSaveSession = async ({
    idReservaAsesoria,
    idMotivo,
    otroMotivo,
    seguimiento,
    codigoAzul,
    asistencia,
    horaInicio,
    horaFin
}) => {
    const [result, err] = await doRequest(
        "/psychotherapyappointment/saveSession", "POST",
        {
            idReservaAsesoria, 
            idMotivo,
            otroMotivo, 
            seguimiento,
            codigoAzul,
            asistencia,
            horaInicio,
            horaFin,
            usuarioCreacion:  getUserId()
        }, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;
    if (dataFetch?.state === 1)
        return dataFetch?.data.save;
    return null;
}
export const requestUpdateSession = async ({
    idReservaAsesoria,
    idMotivo,
    otroMotivo,
    seguimiento,
    codigoAzul,
    asistencia,
    horaInicio,
    horaFin
}) => {
    const [result, err] = await doRequest(
        "/psychotherapyappointment/editSession", "POST",
        {
            idReservaAsesoria, 
            idMotivo,
            otroMotivo, 
            seguimiento,
            codigoAzul,
            asistencia,
            horaInicio,
            horaFin,
            usuarioModificacion:  getUserId()
        }, getToken());
    if (err) 
        return null;
    const { data: dataFetch } = result;

    if (dataFetch?.state === 1)
        return dataFetch?.data.save;
    return null;
}